/* eslint-disable  react/display-name */
import { Grid, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PCheck from "../../../components/pos/PCheck";
import PDatePicker from "../../../components/pos/PDatePicker";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { StringUtils } from "../../../utils/StringUtils";

export default function ShippingCostAccountMappingView(props) {
  const { t } = useTranslation();
  const translate = t;
  //const [ledgerList, setLedgerList] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);

  useEffect(() => {
    // loadShippingCostLedgers();
    populateVendor();
  }, []);

  /*useEffect(() => {
    if (props.costAccountMappingList.length == 0) {
      handleAddRow({
        id: props.selectedVendor.ledgerId,
        name: props.selectedVendor.name,
      });
    }
  }, [props.showShippingCostSplitView]);*/

  async function populateVendor() {
    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id && data[i].ledgerId) {
          dat.push({
            id: data[i].ledgerId,
            name: data[i].name,
          });
        }
      }
      setVendorOptions(dat);
    });
  }

  /*async function loadShippingCostLedgers() {
    let ledgers = await API.get("/api/v1/ledgerlist");
    if (ledgers && ledgers.data) {
      let ledgerListTemp = [];
      ledgers.data.map((ledger) => {
        ledgerListTemp.push({ name: ledger.name, id: ledger.id });
      });
      setLedgerList(ledgerListTemp);
    }
  }*/

  function onCloseWindow() {
    props.setOpenWindow(false);
  }

  function validate() {
    if (props.costAccountMappingList.length == 0) {
      props.showMessage("error", "Please add accounting entry before proceed!");
      return false;
    }
    for (let i = 0; i < props.costAccountMappingList.length; i++) {
      if (props.costAccountMappingList[i].vendorAccount == null) {
        props.showMessage("error", "Vendor not selected at row: " + (i + 1));
        return false;
      }
      if (
        props.costAccountMappingList[i].shippingAmount == null ||
        props.costAccountMappingList[i].shippingAmount == ""
      ) {
        props.showMessage("error", "Shipping cost is empty at row: " + (i + 1));
        return false;
      }
    }
    return true;
  }

  function handleSave() {
    if (validate()) {
      props.handleApplyShippingCost();
      props.setOpenWindow(false);
    }
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let costAccountMappingListTemp = [...props.costAccountMappingList];
    let updatedList = [];
    let index = 0;
    for (let i = 0; i < costAccountMappingListTemp.length; i++) {
      if (tableMeta.rowIndex != i) {
        costAccountMappingListTemp[i].serialNumber = index + 1;
        updatedList.push(costAccountMappingListTemp[i]);
        index++;
      }
    }
    props.setCostAccountMappingList(updatedList);
  }

  function handleAddRow(vendorAccount) {
    let costAccountMappingListTemp = [...props.costAccountMappingList];
    costAccountMappingListTemp.push({
      serialNumber: costAccountMappingListTemp.length + 1,
      vendorAccount: vendorAccount,
      invoiceNumber: "",
      shippingAmount: "",
      taxPercentage: "",
      date: "",
      description: "",
    });
    props.setCostAccountMappingList(costAccountMappingListTemp);
  }

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 350,
  };

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "vendorAccount",
      label: translate("Payment To"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 200 }}>
            <PSelect
              options={vendorOptions}
              value={value}
              onChange={(event, newValue) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].vendorAccount = newValue;
                props.setCostAccountMappingList(tempData);
              }}
            ></PSelect>
          </div>
        ),
      },
    },
    {
      name: "invoiceNumber",
      label: translate("Invoice #"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 120 }}>
            <PText
              value={value}
              type="text"
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].invoiceNumber = e.target.value;
                props.setCostAccountMappingList(tempData);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "shippingAmount",
      label: translate("Amount"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 110 }}>
            <PText
              value={value}
              type="number"
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].shippingAmount = e.target.value;
                props.setCostAccountMappingList(tempData);
                let shippingAmount = 0;
                tempData.map((item) => {
                  if (item.shippingAmount && !item.shippingAmount == "") {
                    shippingAmount += parseFloat(item.shippingAmount);
                  }
                });
                props.setTotalShippingCost(shippingAmount);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "taxPercentage",
      label: translate("Tax %"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value}
              type="number"
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].taxPercentage = e.target.value;
                props.setCostAccountMappingList(tempData);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "date",
      label: translate("Date"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 120 }}>
            <PDatePicker
              value={value}
              onChange={(newValue) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].date =
                  StringUtils.getIsoDate(newValue);
                props.setCostAccountMappingList(tempData);
              }}
            ></PDatePicker>
          </div>
        ),
      },
    },
    {
      name: "description",
      label: translate("Description"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <PText
              value={value}
              type="text"
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].description = e.target.value;
                props.setCostAccountMappingList(tempData);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <table width="100%">
                <tr>
                  <td align="right">Action</td>
                  <td align="right">
                    <Tooltip title={"Add new row"}>
                      <IconButton
                        color="secondary"
                        onClick={() => handleAddRow(null)}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              </table>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right" }}>
            <Tooltip title={translate("Remove")}>
              <IconButton
                color="secondary"
                onClick={() =>
                  onRemoveItemClicked(tableMeta, updateValue, value)
                }
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  const content = (
    <div>
      <Grid container>
        <Grid
          item
          xs={8}
          style={{ paddingTop: "10px", paddingBottom: "10px" }}
        ></Grid>
        <Grid item xs={3} style={{ paddingTop: "10px" }}>
          Total Amount
        </Grid>
        <Grid item xs={1} style={{ paddingTop: "10px" }}>
          <b>{props.totalShippingCost}</b>
        </Grid>
        <Grid item xs={12} sm={12}>
          <MUIDataTable
            data={props.costAccountMappingList}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      {props.openWindow && (
        <PDialog
          content={content}
          title={translate("Shipping cost account mapping")}
          maxWidth={"lg"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={handleSave}
          saveLabel={"Submit"}
          mode={props.mode == "view" ? "view" : "create"}
        ></PDialog>
      )}
    </div>
  );
}
